import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AssistantOutlinedIcon from '@mui/icons-material/AssistantOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import apiService from 'app/services/apiService';

const RecommendationButton = ({
  onRecommend,
  section,
  fwId,
  renderKey,
  questions,
  canRecommend,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'gap_analysis' });

  const [curCanRecommend, setCurCanRecommend] = useState(canRecommend || false);
  const hasMounted = useRef(false);

  const fetchAnswers = async sectId => {
    let res = null;
    try {
      res = await apiService.fetchAnswers(fwId, sectId);
      setCurCanRecommend(res.data.autoRecommend);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (questions) {
      let reRender = false;
      questions.map(question => {
        if (question.id === renderKey || question.id + 'Updated' === renderKey) {
          reRender = true;
        }
      });
      if (hasMounted.current && reRender) {
        fetchAnswers(section.id);
      } else {
        hasMounted.current = true;
        if (canRecommend !== null) {
          setCurCanRecommend(canRecommend);
        }
      }
    }
  }, [fwId, section, renderKey]);

  return (
    <>
      {curCanRecommend ? (
        <Tooltip title={t('get_recommendations')}>
          <IconButton
          component='div'
          variant='text'
          style={{ justifySelf: 'right' }}
          sx={{
            color: ColorsV2.acent,
            '&:hover': {
              color: ColorsV2.white,
              bgcolor: ColorsV2.acent,
            },
          }}
          onClick={e => {
            e.stopPropagation(); // Prevent triggering the accordion expansion -- Outdated, accordion is no longer used. Is this still relevant?
            onRecommend(section.id);
          }}
          >
            <AssistantOutlinedIcon></AssistantOutlinedIcon>
          </IconButton>
        </Tooltip>
      ) : (
        ''
      )}
    </>
  );
};

export default RecommendationButton;
